// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"LocationsList__listWrapper___2if_-","isLoading":"LocationsList__isLoading___9DyJ5"};